import { CLICK_FROM, CLICK_TO, CLICK_MAP,  CLICK_MARKER, CHANGE_FROM, CHANGE_TO, SET_ARRIVAL, SET_DEPARTURE, FIND_ITINERARIES, FIND_ITINERARIES_SUCCESS, FIND_ITINERARIES_FAIL, CLOSE_ROUTE, FIND_ALL_ROUTES, FIND_ALL_ROUTES_FAIL, FIND_ALL_ROUTES_SUCESS, CLOSE_ALL_ROUTES, TOGGLE_CODESHARE_CHECK, GET_ITINERARIES_NETWORK, GET_ITINERARIES_NETWORK_FAIL, GET_ITINERARIES_NETWORK_SUCCESS, TOGGLE_ROUTE_OPTIONS, CHANGE_ITINERARIES_DAY, SELECT_ITINERARY_OPTION, CHANGE_STOP_OPTION, SHOW_ALERT, CLOSE_ALERT, GET_ROUTE_PRICE_SUCCESS, GET_ROUTE_PRICE_FAILED, SHOW_ROUTE_PRICE, HIDE_ROUTE_PRICE} from '../actions';
import { getFindItinerariesSuccessStates, getDayName, getSelectItineraryOptionStates, getChangeScheduleDayStates, getChangeStopOptionState, getFindAllRoutesSuccessState, NON_STOP, getShowRoutePriceState } from '../helpers';

const INITIAL_FILTERS = {
    codeshareChecked: true
}

const INITIAL_STATE = {
    options: [],
    currentOptions: [],
    selectedOptionIdx: 0,
    schedules: [],
    currentSchedules: [],
    scheduleDay: getDayName(),
    filteredSchedules: [],
    segments: [],
    filters: INITIAL_FILTERS,
    stopFilter: NON_STOP,
    showSidebar: false,
    showFromPopup: false,
    showToPopup: false,
    showFromSuggestions: true,
    showToSuggestions: true,
    from: '',
    to: '',
    selectedMarker: '',
    loading: false,
    alert: '',
    routePrice: false,
    routePrices: [],
}

export default function( state = INITIAL_STATE, action ) {
    switch(action.type) { 
        case CLICK_FROM:
            return { ...state, showFromPopup: !state.showFromPopup, showToPopup: false, showFromSuggestions: false };
        case CLICK_TO:
            return { ...state, showToPopup: !state.showToPopup, showFromPopup: false, showToSuggestions: false };
        case CLICK_MAP:
            return { ...state, showFromPopup: false, showToPopup: false, selectedMarker: '', showFromSuggestions: false, showToSuggestions: false };
        case SET_DEPARTURE:
            return { ...state, from: action.payload.from, selectedMarker: '', showFromPopup: false, showFromSuggestions: false };
        case SET_ARRIVAL:
            return { ...state, to: action.payload.to, selectedMarker: '', showToPopup: false, showToSuggestions: false };
        case CLICK_MARKER:
            return { ...state, selectedMarker: action.payload.markerId };  
        case CHANGE_FROM:
            let showFromPopup = state.showFromPopup;
            let showFromSuggestions = state.showFromSuggestions;
            if (action.payload.from !== '') {
                showFromPopup = false;
                showFromSuggestions = true;
            }

            return { ...state, from: action.payload.from, showFromPopup, showFromSuggestions };
        case CHANGE_TO:
            let showToPopup = state.showToPopup;
            let showToSuggestions = state.showToSuggestions;
            if (action.payload.to !== '') {
                showToPopup = false;
                showToSuggestions = true;
            }

            return { ...state, to: action.payload.to, showToPopup, showToSuggestions };    
        case FIND_ITINERARIES:
            return { ...state, loading: true, showFromPopup: false, showToPopup: false, routePrice: false };
        case FIND_ITINERARIES_FAIL:
            return { ...state, from: '', to: '', options:[], currentOptions:[], selectedOptionIdx: 0, schedules: [], filteredSchedules: [], currentSchedules: [], loading: false, showSidebar:false, segments:[], routePrice: false };
        case FIND_ITINERARIES_SUCCESS:
            return getFindItinerariesSuccessStates(action.payload.data, state, action.payload.from, action.payload.to);
        case SELECT_ITINERARY_OPTION:
            return getSelectItineraryOptionStates(action.payload.idx, state);
        case CHANGE_ITINERARIES_DAY:
            return getChangeScheduleDayStates(action.payload.day, state);
        case CHANGE_STOP_OPTION:
            return getChangeStopOptionState(action.payload.stopOption, state);
        case TOGGLE_CODESHARE_CHECK:
            state.filters.codeshareChecked = action.payload.checked;
            return { ...state};
        case GET_ITINERARIES_NETWORK:
            return { ...state, loading: true };
        case GET_ITINERARIES_NETWORK_SUCCESS:
            return { ...state, loading:false, segments: action.payload.data, options:[], currentOptions:[], selectedOptionIdx: 0, schedules: [], filteredSchedules: [], currentSchedules: [], showSidebar:false, from: '', to: '', routePrice: false};
        case GET_ITINERARIES_NETWORK_FAIL:
            return { ...state, from: '', to: '', options:[], currentOptions:[], selectedOptionIdx: 0, schedules: [], filteredSchedules: [], currentSchedules: [], loading: false, showSidebar:false, segments:[], routePrice: false };
        case TOGGLE_ROUTE_OPTIONS:
            return { ...state, showSidebar: action.payload.showSidebar };
        case CLOSE_ROUTE:
            return { ...state, from: '', to: '', options:[], currentOptions:[], selectedOptionIdx: 0, schedules: [], filteredSchedules: [], currentSchedules: [], loading: false, showSidebar:false, segments:[], routePrice: false};
        case FIND_ALL_ROUTES:
            return { ...state, loading: true, from: action.payload.from, selectedMarker: '', to: '' };
        case FIND_ALL_ROUTES_FAIL:
            return { ...state, from: '', to: '', options:[], currentOptions:[], selectedOptionIdx: 0, schedules: [], filteredSchedules: [], currentSchedules: [], loading: false, showSidebar:false, segments:[], routePrice: false };
        case FIND_ALL_ROUTES_SUCESS:
            return getFindAllRoutesSuccessState(action.payload.data, state);
        case CLOSE_ALL_ROUTES:
            return { ...state, from: '', to: '', options:[], currentOptions:[], selectedOptionIdx: 0, schedules: [], filteredSchedules: [], currentSchedules: [], loading: false, showSidebar:false, segments:[], routePrice: false };
        case SHOW_ALERT:
            return { ...state, alert: action.payload.alert, loading: false };
        case CLOSE_ALERT: 
            return { ...state, alert: '' };
        case GET_ROUTE_PRICE_FAILED:
            return { ...state, routePrices: [] };
        case GET_ROUTE_PRICE_SUCCESS:
            return { ...state, routePrices: action.payload.data };
        case SHOW_ROUTE_PRICE:
            return getShowRoutePriceState(action.payload.from, action.payload.to, state);
        case HIDE_ROUTE_PRICE:
            return { ...state, routePrice: false };
        default:
            return state;
    }
}
